import DefaultLayout from '@/layouts/Default'
import DisabledLayout from '@/layouts/Disabled'
import EmptyLayout from '@/layouts/Empty'
import FakeSiteLayout from '@/layouts/fakeSite/FakeSite'
import LoadingLayout from '@/layouts/Loading'

export default { DefaultLayout, DisabledLayout, EmptyLayout, FakeSiteLayout, LoadingLayout }
